import { Component, computed, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { Kunde } from '@features/kunder/kunde.model';
import { LetInputCprComponent } from '@shared/let-input-cpr/let-input-cpr.component';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { ScrollPanel } from 'primeng/scrollpanel';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { LetregisterService } from '../letregister.service';
import { LetsikringSearchParams } from './letsikring-search-params.model';

@Component({
  selector: 'app-letregister-search',
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    Button,
    InputText,
    Message,
    ScrollPanel,
    TableModule,
    TableRowDirective,
    CprNummerPipe,
    LetInputCprComponent,
  ],
  templateUrl: './letregister-search.component.html',
  styleUrl: './letregister-search.component.css',
})
export class LetregisterSearchComponent {
  letregisterService = inject(LetregisterService);
  validationMessage = signal('');
  kunder = signal<Kunde[]>([]);

  form = new FormGroup({
    cprNr: new FormControl(), //'0505812406' LTS
    letsikringNr: new FormControl(), //51312275 Livrente  //31002530 Krydsliv // 31002606 Død RAP
    pfaPoliceNr: new FormControl(),
  });

  async onClickSearch() {
    const searchParams = this.form.value as LetsikringSearchParams;
    if (
      !searchParams.cprNr &&
      !searchParams.letsikringNr &&
      !searchParams.pfaPoliceNr
    ) {
      return;
    }

    this.kunder.set([]);
    const response = await this.letregisterService.searchLetsikring({
      ...searchParams,
    });
    const letsikringer = response.data;

    const distinctKunder: Kunde[] = [];
    letsikringer.forEach(l => {
      if (l.kunde) {
        const kundeExists = distinctKunder.filter(
          k => k.id === l.kundeId
        ).length;
        if (kundeExists == 0) {
          distinctKunder.push(l.kunde);
        }
      }
    });
    this.kunder.set(distinctKunder);

    if (distinctKunder.length === 1) {
      this.letregisterService.selectKunde(distinctKunder[0]);
    }
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.letregisterService.letsikringDatasource.isLoaded() &&
      this.letregisterService.letsikringDatasource.data()?.totalRowCount == 0
    );
  });

  onKundeSelect(e: TableRowSelectEvent) {
    this.letregisterService.selectKunde(e.data);
  }
}
